import React, { useEffect, useState } from 'react';
import { Table, Input, Button, Space, Tag } from 'antd';
import {
  FileOutlined,
  FolderOutlined,
  PlusOutlined,
  FilterOutlined,
  DatabaseOutlined,
  ProjectOutlined,
} from '@ant-design/icons';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const ListTrashContent = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');

  const { spaceid } = useParams();
  const queryClient = useQueryClient();

  const handleRestore = async (record) => {
    try {
      const payload = {
        space_id: Number(spaceid),
        item_id: record.item_id,
        status_type: record.status,
        nested_item: record.parent_id ? 'yes' : 'no',
        parent_id: record.parent_id || null,
      };

      const response = await httpInjectorService.restoreTrashedContent(payload);

      if (response?.status === 'success') {
        toast.success(response.message, {
          autoClose: 1000,
          position: 'top-right',
        });
        handleGetItems();
        queryClient.invalidateQueries(['spaceContent', Number(spaceid)]);
      }
    } catch (error) {
      console.error('Restore failed', error);
      toast.error(error.message, {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };

  const handleDelete = async (item_id) => {
    try {
      const response = await httpInjectorService.permanentlyDeleteItem(
        spaceid,
        item_id,
      );
    
      if (response.status === 'success') {
        toast.success(response.message, {
          autoClose: 1000,
          position: 'top-right',
        });
        handleGetItems();
      }
    } catch (error) {
      toast.error(error.message, {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };

  const filteredData = data.filter((item) =>
    item.title?.toLowerCase().includes(search.toLowerCase()),
  );

  const handleGetItems = async () => {
    try {
      const response =
        await httpInjectorService.getArchivedandDeletedItems(spaceid);
      if (response.status === 'success') {
        setData(response.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleGetItems();
  }, [spaceid]);

  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => (
        <Space>
          {record.item_type === 'folder' && (
            <FolderOutlined style={{ color: '#fa8c16' }} />
          )}
          {record.item_type === 'page' && (
            <FileOutlined style={{ color: '#fa8c16' }} />
          )}
          {record.item_type === 'whiteboard' && (
            <ProjectOutlined style={{ color: '#fa8c16' }} />
          )}
          {record.item_type === 'database' && (
            <DatabaseOutlined style={{ color: '#fa8c16' }} />
          )}
          <span>{record.title}</span>
        </Space>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'updated_at',
      key: 'date',
      render: (date) => {
        if (!date) return '-';

        return new Date(date).toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'deleted' ? 'red' : 'orange'}>{status}</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <span
            style={{ color: '#1677ff', cursor: 'pointer' }}
            onClick={() => handleRestore(record)}
          >
            Restore
          </span>
          <span
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={() => handleDelete(record.item_id)}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 20,
        }}
      >
        <Input
          placeholder="Search"
          style={{ width: 200 }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div
        style={{
          borderRadius: 12,
          padding: 10,
        }}
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          pagination={false}
        />
      </div>
    </div>
  );
};

export default ListTrashContent;
